/* eslint-disable no-mixed-spaces-and-tabs */
import React from "react";
import { connect } from "react-redux";
import { historicoSiniestros } from "./seguimientoSiniestro.act";
import DetalleSeguimientoSiniestro from "./detalleSeguimientoSiniestro.cmpt";
import FormaPago from "../../pago-deducible-auto/pago/pago.cmpt";
import ModalError from "../../pago-deducible-auto/modal-error/modal-error.cmpt";
import {
	datosPagoDeducible,
	getDetallePago,
	getReferenciaBancaria,
	postEstatusPago,
	setGetDetallePago,
} from "../../pago-deducible-auto/pagoDeducibleAuto-actions";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import { formatDateSSRep } from "../../tools";
import "./seguimientoSiniestro.css";
import moment from "moment";

const idReturnPageSiniestros = "#returnPageSiniestros";

const mapState = (state) => {
	return {
		polizas: state.polizas.autos,
		siniestros: state.siniestros.sreparacion,
		lastlogin: state.global.lastlogin,
		aviso: state.siniestros.aviso,
		exitoGetDetalle: state.pagoDeducibleAutos.getDetallePago,
		tokenId: state.global.tid,
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ type: "LOADER", show: show });
		},
		historicoSiniestros: (polizas, tID) => {
			dispatch(historicoSiniestros(polizas, tID));
		},
		setSelect: (siniestro) => {
			dispatch({ type: "SINIESTROS_SET_SELECT_REP", select: siniestro });
		},
		addEvento: (evento) => {
			dispatch({ type: "SEG_SIN_SET_EVENT", evento: evento });
		},
		onSetDataPagoDeducible: (dataPagoDeducible) => {
			dispatch(datosPagoDeducible(dataPagoDeducible));
		},
		onGetDetallePago: (codigoSiniestro, tID) => {
			return dispatch(getDetallePago(codigoSiniestro, tID));
		},
		onGetReferenciaBancaria: (codigoSiniestro, tID) => {
			return dispatch(getReferenciaBancaria(codigoSiniestro, tID));
		},
		onSetGetDetallePago: (dataGetDetalle) => {
			dispatch(setGetDetallePago(dataGetDetalle));
		},
		onPostEstatusPago: (listaSiniestros, tID) => {
			return dispatch(postEstatusPago(listaSiniestros, tID));
		},
	};
};

export class SeguimientoSiniestro extends React.Component {
	noHided = 0;
	numRegistros = 10;
	anchorEl = null;
	state = {
		openModalPago: false,
		openModalVacio: false,
		openModalError: false,
		verDetalle: false,
		currentPage: 0,
		optionPago: "",
		formasPago: false,
		datosPagoDeducibleAuto: {},
		datosReferenciaBancaria: {},
		arrayStatus: [],
		responseStatus: [],
	};

	handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	handlePopoverClose = () => {
		setAnchorEl(null);
	};

	fncVerDetalle = (siniestro) => {
		$(idReturnPageSiniestros).show();
		this.props.setSelect(siniestro);
		this.setState({ verDetalle: true });
		this.props.addEvento("Seg sin selección");
	};

	componentDidMount() {
		$(document).ready(() => {
			$(idReturnPageSiniestros).on("click", () => {
				$(idReturnPageSiniestros).hide();
				this.setState({ verDetalle: false });
			});
		});
	}

	componentWillReceiveProps = (nextProps) => {
		if (this.props.polizas !== nextProps.polizas) {
			var lista_polizas = nextProps.polizas;
			const polizas = [];
			if (lista_polizas.length) {
				// CORRECCION EN CASO DE QUE LA LOGICA INCORRECTA DE ARRIBA CARGUE MAL LAS POLIZAS
				for (var pol of lista_polizas) {
					polizas.push({
						numPoliza: pol.generales.numPoliza,
						fchInicio: formatDateSSRep(pol.generales.fchVigenciaInicial),
						fchFin: formatDateSSRep(pol.generales.fchVigenciaFinal),
					});
				}
			}
			this.props.historicoSiniestros(polizas, this.props.tokenId);
		}

		if (nextProps.aviso) {
			$("#modal-infoact").modal("show");
		}
	};

	numUltRegistro() {
		return this.state.currentPage * this.numRegistros + this.numRegistros;
	}

	goToPage = (i) => {
		if (i < 0 || i * this.numRegistros > this.props.siniestros.length) {
			return;
		}
		this.noHided = 0;
		this.setState({
			currentPage: i,
		});
		this.props.addEvento("Navegación ant sig");
	};

	showRow(state, i, poliza) {
		var rangePage =
			this.numRegistros * state.currentPage <= this.noHided &&
			this.noHided < this.numRegistros * (state.currentPage + 1) - 1;

		this.noHided += 1;

		if (rangePage) {
			/*Para reensamblado de paginas*/
			return true;
		} else {
			return false;
		}
	}

	calcularPaginas = () => {
		var numPaginas = 0;

		if (this.props.siniestros) {
			numPaginas = Math.ceil(this.noHided / this.numRegistros);
		}
		return numPaginas;
	};

	handleModalFormasPago = (event, option) => {
		event.stopPropagation();
		this.setState({
			openModalPago: true,
			datosPagoDeducibleAuto: { ...option },
		});
	};

	accionButton = (event) => {
		if (event === "button2") {
			this.props
				.onGetReferenciaBancaria(
					this.state.datosPagoDeducibleAuto.codSiniestroPadre,
					this.props.tokenId
				)
				.then((response) => {
					this.props.onSetDataPagoDeducible({
						...this.state.datosPagoDeducibleAuto,
					});
					this.setState({
						optionPago: "ventanilla",
						formasPago: true,
						datosReferenciaBancaria: {
							nombreDocumento: response.data.nombreDocumento,
							urlVisualizacion: response.data.urlVisualizacion,
							base64: response.data.base64
						},
					});
				})
				.catch((error) => {
					this.props.onSetDataPagoDeducible({
						...this.state.datosPagoDeducibleAuto,
					});
					this.setState({
						optionPago: "ventanilla",
						formasPago: true,
						datosReferenciaBancaria: {
							nombreDocumento: "",
							urlVisualizacion: "",
							base64: ""
						},
					});
				});
		} else if (event === "button1") {
			this.props.onSetDataPagoDeducible({
				...this.state.datosPagoDeducibleAuto,
			});
			this.setState({
				optionPago: "linea",
				formasPago: true,
			});
		}
	}

	showModalError = (status) =>{
		if (status === 204 || status === 404) {
			this.props.loader(false);
			this.setState({
				openModalVacio: true,
			});
		} else {
			this.props.loader(false);
			this.setState({
				openModalError: true,
			});
		}
	}

	handleFormasPago = (event) => {
		if (event === "buttonIcon") {
			this.setState({
				openModalPago: false,
			});
		} else {
			this.setState({
				openModalPago: false,
			});
			this.props.loader(true);
			this.props
				.onGetDetallePago(
					this.state.datosPagoDeducibleAuto.codSiniestroPadre,
					this.props.tokenId
				)
				.then((responseGet) => {
					if (responseGet.status === 200) {
						this.props.onSetGetDetallePago({ ...responseGet.data });
						this.accionButton(event);
					}
				})
				.catch((error) => {
					console.error(error);
					if (error && error.response && error.response.status) {
						this.showModalError(error.response.status);
					} else {
						this.props.loader(false);
						this.setState({
							openModalError: true,
						});
					}
				});
		}
	};

	handleRegresar = () => {
		this.setState({
			formasPago: false,
			verDetalle: false,
		});
	};

	handleCloseModalError = () => {
		this.setState({
			openModalError: false,
		});
	};

	handleCloseModalVacio = (event) => {
		this.setState({
			openModalVacio: false,
		});
	};

	handleCloseModalPago = () => {
		this.setState({
			openModalPago: false,
		});
	};

	componentWillMount = () => {
		console.log(this.props.polizas);
		var lista_polizas = this.props.polizas;
		const polizas = [];
		if (lista_polizas.length) {
			// CORRECCION EN CASO DE QUE LA LOGICA INCORRECTA DE ARRIBA CARGUE MAL LAS POLIZAS
			for (var pol of lista_polizas) {
				polizas.push({
					numPoliza: pol.generales.numPoliza,
					fchInicio: formatDateSSRep(pol.generales.fchVigenciaInicial),
					fchFin: formatDateSSRep(pol.generales.fchVigenciaFinal),
				});
			}
		}
		this.props.historicoSiniestros(polizas, this.props.tokenId);
	};

	handleRegresarPago = (e) => {
		this.setState({
			formasPago: e,
		});
	};

	render() {
		const modalPago = (
			<ModalError
				iconButton={true}
				tipoPago={true}
				openModal={this.state.openModalPago}
				msjTitle="Selecciona tu método de pago"
				msjBody={`Para continuar, elige o registra un método de pago o, si lo prefieres, descarga los documentos, 
			  imprímelos y realiza el pago en la institución bancaria de tu preferencia.`}
				withButtons={{
					actionButtons: true,
					msjButton1: "Pago en linea",
					msjButton2: "Ver referencias bancarias",
				}}
				handleClose={(e) => this.handleFormasPago(e)}
			/>
		);

		const modalVacio = (
			<ModalError
				iconButton={true}
				openModal={this.state.openModalVacio}
				msjTitle="Sin resultados"
				msjBody="No se encontraron resultados."
				handleClose={(e) => this.handleCloseModalVacio(e)}
			/>
		);

		const modalError = (
			<ModalError
				iconButton={true}
				openModal={this.state.openModalError}
				msjTitle="Servicio no disponible"
				msjBody="Intente nuevamente"
				handleClose={(e) => this.handleCloseModalError(e)}
			/>
		);

		return (
			<div className="container siniestros-container">
				{!this.state.verDetalle && (
					<div className="container">
						<div className="col-sm-12">
							{!!this.props.siniestros.length && !this.state.formasPago && (
								<table className="table mt-20 mb-20 tabla-seguimiento-siniestro">
									<thead>
										<tr>
											<th width="20%">Póliza</th>
											<th width="20%">Siniestro</th>
											<th width="20%">Fecha de ocurrencia</th>
											<th width="30%">Estatus</th>
											<th width="10%">Acciones</th>
										</tr>
									</thead>
									<tbody>
										{this.props.siniestros
											.slice(
												this.state.currentPage * this.numRegistros,
												this.state.currentPage * this.numRegistros +
												this.numRegistros
											)
											.map((item, i) => (
												<tr
													key={i}
													className={" siniestro-color-" + (item.color || "")}
													onClick={this.fncVerDetalle.bind(this, item)}
												>
													<td>{item.numPoliza}</td>
													<td>{item.codSiniestroPadre}</td>
													<td>
														{moment(item.fchOcurrencia, "DD-MM-YYYY").format(
															"DD/MM/YYYY"
														)}
													</td>
													<td>
														<div className="siniestro-status-container">
															<div>
																<div className="status-dot"></div>
																{item.estatus}
															</div>
															{/* <a className="siniestro-eye-btn">
												<i className="glyphicon glyphicon-eye-open"></i>
											</a> */}
														</div>
													</td>
													<td className="tdHoverAcciones">
														{item.estatusPago && (
															<button
																className="hoverAcciones buttonPagar tool-tip-pago"
																onClick={(e) =>
																	this.handleModalFormasPago(e, item)
																}
															>
																<a data-tooltip-naranja="Pagar">
																	<CreditCardIcon
																		style={{
																			width: "24px",
																			height: "24px",
																			color: "#FF6B0B",
																		}}
																	></CreditCardIcon>
																</a>
															</button>
														)}
													</td>
												</tr>
											))}
									</tbody>
									<tfoot>
										<tr>
											<td colSpan="5">
												<div className="siniestro-paginator">
													{this.state.currentPage * this.numRegistros + 1} -{" "}
													{this.numUltRegistro() > this.props.siniestros.length
														? this.props.siniestros.length
														: this.numUltRegistro()}{" "}
													de {this.props.siniestros.length}
													<a
														className={
															this.state.currentPage < 1 ? "arrow-disabled" : ""
														}
														onClick={this.goToPage.bind(
															this,
															this.state.currentPage - 1
														)}
													>
														<img
															src={require("../../img/flecha-izquierda.svg")}
														/>
													</a>
													<a
														className={
															this.numUltRegistro() >
																this.props.siniestros.length
																? "arrow-disabled"
																: ""
															// eslint-disable-next-line no-mixed-spaces-and-tabs
														}
														onClick={this.goToPage.bind(
															this,
															this.state.currentPage + 1
														)}
													>
														<img src={require("../../img/flecha-abajo.svg")} />
													</a>
												</div>
											</td>
										</tr>
									</tfoot>
								</table>
							)}
							{!this.props.siniestros.length && (
								<div className="no-siniestros-container">
									<div>
										<span>No hay algún reporte de siniestro en proceso.</span>
									</div>
									<img src={require("./no-siniestros.svg")} />
								</div>
							)}
						</div>
						{this.state.openModalError && modalError}
						{this.state.openModalVacio && modalVacio}
						{this.state.openModalPago && modalPago}
					</div>
				)}
				{this.state.verDetalle && <DetalleSeguimientoSiniestro />}

				{this.state.formasPago && (
					<div>
						<FormaPago
							handleRegresar={(e) => this.handleRegresarPago(e)}
							optionPago={this.state.optionPago}
							pagoDeducibleAuto={this.state.datosPagoDeducibleAuto}
							datosReferenciaBancaria={this.state.datosReferenciaBancaria}
						/>
					</div>
				)}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(SeguimientoSiniestro);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/seguimientoSiniestro/seguimientoSiniestro.cmpt.js